import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { toCombinedValue, toSelectedValues } from '@shared/functions/utils.type';
import { SelectOption } from '@shared/models/shared/select-option.model';
import { startWith } from 'rxjs';

@Component({
	selector: 'formly-multi-select-type',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatFormField, MatLabel, MatHint, MatSelect, MatOption],
	template: `
        <mat-form-field class="w-full">
            <mat-label>{{ props.label }}</mat-label>
            <mat-select multiple [value]="selected()" [disabled]="formControl.disabled" [required]="props.required"
                (selectionChange)="onSelectionChange($event.value)" (closed)="formControl.markAsTouched()">
                @for (item of selectOptions; track item.value) {
                    <mat-option [value]="item.value">{{ item.label }}</mat-option>
                }
            </mat-select>
            @if (props.description) {
                <mat-hint>{{ props.description }}</mat-hint>
            }
        </mat-form-field>
    `,
})
export class MultiSelectTypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
	private destroyRef = inject(DestroyRef);

	readonly selected = signal<number[]>([]);

	get selectOptions(): SelectOption[] {
		return (this.props.options as SelectOption[]) ?? [];
	}

	ngOnInit(): void {
		this.formControl.valueChanges
			.pipe(startWith(this.formControl.value), takeUntilDestroyed(this.destroyRef))
			.subscribe((value: number | null) => this.selected.set(toSelectedValues(value)));
	}

	onSelectionChange(options: number[]): void {
		this.formControl.setValue(toCombinedValue(options));
		this.formControl.markAsDirty();
	}
}
